import { render } from "./TimeWheel.vue?vue&type=template&id=7cff1f06&scoped=true"
import script from "./TimeWheel.vue?vue&type=script&lang=js"
export * from "./TimeWheel.vue?vue&type=script&lang=js"

import "./TimeWheel.css?vue&type=style&index=0&id=7cff1f06&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cff1f06"]])

export default __exports__